export default __webpack_public_path__ + "static/general_healthcare_w.c1a120ad9df1fd056e8dbef70107d583.svg";